import React, { Component } from "react";
import Icons from "../../icon";

export class TheadExhibit1 extends Component {
  
    handleClick = (value) => (event) => this.props.onColumnClick(value);

    render() {
        return (
            <thead>
                <tr>
                    {Object.entries(this.props.columns).map(([key, value]) => {
                        if (!value.hidden) {
                            return (
                                <th key={"thead-" + value.name} onClick={this.handleClick(key)} hidden={value.hidden}>
                                    <div className="header-content">
                                        <span>{value.name} </span>  
                                        {value.isSortedAsc ?                                   
                                            <Icons
                                                name="sort-up-solid"
                                                size="14px"
                                                customClassName="icon-table-header icon-up-sort"
                                            />
                                        : 
                                            <Icons
                                                name="sort-down-solid"
                                                size="14px"
                                                customClassName="icon-table-header"
                                            />
                                         }                                       
                                    </div>
                                </th>
                            );
                        }
                    })}
                </tr>
            </thead>
        );
    }
}
